import React from 'react';
import { Sidebar } from 'react-admin';

const SIDEBAR_WIDTH = 72;

const AppSideBar = (props) => {
  return (
    <Sidebar
      {...props}
      sx={{
        width: SIDEBAR_WIDTH,
        '& .RaSidebar-fixed': {
          width: SIDEBAR_WIDTH,
        },
        '& .MuiDrawer-paper': {
          width: SIDEBAR_WIDTH,
        },
        '& .RaSidebar-paper': {
          width: SIDEBAR_WIDTH,
        },
      }}
    />
  );
};

export default AppSideBar;
